import { Facebook } from "lucide-react";

export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center">
      <img
        src="/images/park-bridge.webp"
        alt="Lush gardens and walkways of Davao Memorial Park"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0C2340]/90 via-[#0C2340]/60 to-[#0C2340]/20" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-8 pt-32 pb-20 w-full">
        <div className="max-w-2xl">
          <p data-testid="hero-eyebrow" className="text-xs font-semibold uppercase tracking-[0.25em] text-[#C59B27] mb-6">
            Davao City's Premier Memorial Park
          </p>
          <h1 data-testid="hero-heading" className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold text-white tracking-tight leading-[1.1]">
            Where yesterdays are remembered for many tomorrows
          </h1>
          <p data-testid="hero-subtitle" className="mt-6 text-base sm:text-lg text-white/85 leading-relaxed">
            To our kababayan working abroad — give your family the gift of a
            peaceful, dignified resting place back home. Discover Davao Memorial
            Park and our newest project, the In Aeternum Columbarium, wherever
            you are in the world.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="#inquire"
              data-testid="hero-inquire-btn"
              className="bg-[#C59B27] hover:bg-[#b08b22] text-[#0C2340] font-semibold px-8 py-3.5 rounded-full transition-all duration-300 hover:-translate-y-0.5 shadow-lg shadow-[#C59B27]/25"
            >
              Inquire About the Columbarium
            </a>
            <a
              href="https://www.facebook.com/DavaoMemorialPark"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-facebook-link"
              className="inline-flex items-center gap-2 border border-white/50 text-white hover:bg-white/10 font-medium px-8 py-3.5 rounded-full transition-colors"
            >
              <Facebook className="w-4 h-4" />
              Visit Our Facebook Page
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
